//import { merge } from "lodash";

module dgUtils {

    export class ObjectHelperService {

        public static isObject(item) {
            return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
        }

        //Deep merge - https://stackoverflow.com/a/49798508/3437914
        //Tuned to work with arrays properly
        public static mergeDeep(target, source): any {
            var mergeFunc = window["merge"];

            if (target === undefined || target === null) target = {};

            mergeFunc(target, source);
            return target;
            //if (sources.length == 0) {
            //    throw new Error("The sources array should not be emplty");
            //}

            //let definedSources = sources.filter(a => a != null && a != undefined);

            //if (definedSources.length == 0) {
            //    return null;
            //}

            //if (definedSources.filter(a => !ObjectHelperService.isObject(a)).length > 0) {
            //    throw new Error("All sources should be of type object");
            //}

            //let acc: any = {};
            //for (const source of definedSources) {
            //    for (let [key, value] of (Object as any).entries(source)) {

            //        let sourceVal = key in acc ? acc[key] : null;
            //        value = ObjectHelperService.mergeValue(sourceVal, value);

            //        acc = { ...acc, [key]: value }

            //    }
            //}
            //return acc;
        }


        public static mergeArrayDeep(...sources: Array<any>[]): any[] {
            if (sources.length == 0) {
                throw new Error("The sources array should not be emplty");
            }

            let definedSources = sources.filter(a => a != null && a != undefined);

            if (definedSources.length == 0) {
                return null;
            }

            if (definedSources.filter(a => !(a instanceof Array)).length > 0) {
                throw new Error("All sources should be of type array");
            }


            let acc: Array<any> = [];
            for (const source of definedSources) {

                for (let i = 0; i < source.length; i += 1) {
                    let value = source[i];

                    if (i >= acc.length) {
                        acc.push(null);
                    }

                    let sourceVal = acc[i];
                    value = ObjectHelperService.mergeValue(sourceVal, value);

                    acc[i] = value;
                }
            }
            return acc
        }


        private static mergeValue(sourceVal: any, value: any) {
            if (Array.isArray(value)) {
                sourceVal = sourceVal == null ? [] : sourceVal;
                value = dgUtils.ObjectHelperService.mergeArrayDeep(sourceVal, value);
            }
            else if (ObjectHelperService.isObject(value)) {
                sourceVal = sourceVal == null ? {} : sourceVal;
                value = dgUtils.ObjectHelperService.mergeDeep(sourceVal, value);
            }
            return value;
        }


        //public static mergeDeep(target, ...sources): any {
        //    if (target instanceof Array) {
        //        let arr = []
        //        arr = [...(arr as any), ...sources]
        //        return arr;
        //    }

        //    if (!sources.length) return target;
        //    const source = sources.shift();
        //    if (dgUtils.ObjectHelperService.isObject(target) && dgUtils.ObjectHelperService.isObject(source)) {
        //        for (const key in source) {
        //            if (dgUtils.ObjectHelperService.isObject(source[key])) {
        //                if (!target[key]) (Object as any).assign(target, { [key]: {} });
        //                dgUtils.ObjectHelperService.mergeDeep(target[key], source[key]);
        //            } else {
        //                (Object as any).assign(target, { [key]: source[key] });
        //            }
        //        }
        //    }

        //    return dgUtils.ObjectHelperService.mergeDeep(target, ...sources);
        //}

        //public static deepMerge(destination, source) {
        //    for (var property in source) {
        //        if (typeof source[property] === "object" &&
        //            source[property] !== null) {
        //            destination[property] = destination[property] || {};
        //            arguments.callee(destination[property], source[property]);
        //        } else {
        //            destination[property] = source[property];
        //        }
        //    }
        //}
    }

    angular.module('dgUtils')
        .service('objectHelperService', ObjectHelperService);
}

